export default "__VITE_ASSET__317370b9__"